import React from "react";
import AnimationRevealPage from "helpers/AnimationRevealPage.js";
import Hero from "components/hero/TwoColumnWithFeaturesAndTestimonial2.js";
import GetStarted2 from "components/cta/GetStartedLight2.js";

export default () => {
  return (
    <AnimationRevealPage>
      <Hero />
      <section id = "demo" className = "flex items-center justify-center space-x-4">
      <GetStarted2/>
      </section>
    </AnimationRevealPage>
  );
}
